export const GROUPS_SET_LIST_DATA = 'GROUPS_SET_LIST_DATA';
export const GROUPS_SET_LIST_META = 'GROUPS_SET_LIST_META';
export const GROUPS_TITLE="Nhóm người dùng";